export default () => ({
  links: [],
  init() {
    this.$el.querySelectorAll('.anchor').forEach((el, i) => {
      let text = el.textContent.trim();
      const normalizedSlug = text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
      const url = `#${normalizedSlug || `section_${i + 1}`}`;
      let num = i + 1;
      text = `<strong class="number">${num < 10 ? '0'+num : num}</strong> ${text}`;

      el.id = url.substring(1);
      el.innerHTML = text;

      this.links.push({
        title: text,
        url,
      });
    })
  },
  toAnchor(e) {
    e.preventDefault();
    const url = e.currentTarget.getAttribute('href');
    const el = document.querySelector(url);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;

      window.scrollTo({
        top: Math.max(top, 0),
        behavior: 'smooth',
      });
    }
  }
})